import { render, staticRenderFns } from "./Benutzer.vue?vue&type=template&id=0e8d0820&scoped=true"
import script from "./Benutzer.vue?vue&type=script&lang=ts"
export * from "./Benutzer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d0820",
  null
  
)

export default component.exports